const useBodyFixed = () => {
    return {
        fixed: () => (document.body.style.overflowY = "hidden"),
        unfixed: () => (document.body.style.overflowY = "auto"),
    };
};

export default useBodyFixed;
